export const dayModifiersClassNames = {
  picked: '[&>button]:bg-primary-400 [&>button]:text-white [&>button:hover]:bg-primary-600',
  skipped:
    '[&>button]:bg-neutral-100 [&>button]:text-neutral-400 [&>button]:line-through [&>button:hover]:bg-neutral-200',
};
